import {
  ApiPagination, BaseResponse, Filters, FiltersPagination, Response,
} from '@/types';
import { BaseApiService } from '@/services/base-service';
import { Patchnotes } from '../types';

interface PatchnotesList extends BaseResponse, ApiPagination {
  data: {
    items: Patchnotes.PatchNote[],
    dates: string[],
    regions: string[],
  }
}

export class PatchNotesService extends BaseApiService {
  private readonly base_path = 'news/patch_notes';

  async get_patchnotes(filters: FiltersPagination<Filters>): Promise<PatchnotesList> {
    const payload = filters;

    const { data } = await this.http_client.get<PatchnotesList>(this.base_path, {
      params: {
        filters: payload.filters,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }
}
